/* eslint-disable */
/**
 * Redirect the plural form of `orders` to `order`
 * @export
 */
export const ORDER_PLURAL_PAGE_REDIRECT = `/orders/:orderId`;

/**
 * The path of the `OrderPage` to be consumed by a `<Router />`
 * @export
 */
export const ORDER_PAGE_PATH = `/order/:orderId`;

/**
 * Create a `href` that will resolve to `OrderPage`
 * @export
 * @param {{ orderId: string }} params The dynamic params that need to be matched
 * @returns {string} The `ORDER_PAGE_PATH`
 */
export const createOrderPageLink = ({ orderId }) => `/order/${orderId}`;

/**
 * Determine if the current page is the `OrderPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `OrderPage`
 */
export const isOrderPage = (match) => match.path === ORDER_PAGE_PATH;
